// Lagano čitanje JWT payload-a (BEZ verifikacije potpisa — za to se brine backend).
// Koristi se samo za UI hint-ove (banner ako impersonating, super-admin nav item, itd.).

export interface JwtClaims {
  sub?: string;
  exp?: number;
  iat?: number;
  tenant_id?: number | null;
  is_super_admin?: boolean;
  uid?: number;
  impersonating?: boolean;
}

export function decodeJwtClaims(token: string | null | undefined): JwtClaims | null {
  if (!token) return null;
  const parts = token.split(".");
  if (parts.length !== 3) return null;
  const middle = parts[1];
  if (!middle) return null;
  try {
    // Base64url decode middle segment
    const padded = middle.replace(/-/g, "+").replace(/_/g, "/");
    const padding = padded.length % 4 === 0 ? 0 : 4 - (padded.length % 4);
    const decoded = atob(padded + "=".repeat(padding));
    return JSON.parse(decoded) as JwtClaims;
  } catch {
    return null;
  }
}
